<template>
    <v-container class="wrapper-send-message pa-0">
        <v-container
            v-if="filePreviews != null && filePreviews.length > 0"
            class="wrapper-attachment pa-0"
        >
            <!--image-->
            <div
                class="d-flex align-center gap-2"
                style="flex-wrap: wrap;"
            >
                <div
                    v-for="(file, index) in filePreviews"
                    :key="index"
                    v-if="resolveImgExtension(file.type)"
                    class="wrapper-images"
                >
                    <img
                        :src="file.preview"
                        class="attached-img"
                    />
                    <div
                        class="close-btn img"
                        @click="removeItem(index)"
                    >
                        <v-icon color="#fff" style="font-size: 18px !important;">mdi-close</v-icon>
                    </div>
                </div>
            </div>
            <!--document-->
            <div
                class="d-flex align-center"
                style="flex-wrap: wrap;column-gap: 1rem;"
            >
                <div
                    v-for="(file, index) in filePreviews"
                    :key="index"
                    class="d-flex align-center gap-2 wrapper-files mb-3"
                    v-if="resolveDocExtension(file.type)"
                >
                    <img
                        src="https://cdn-icons-png.flaticon.com/512/11180/11180756.png"
                        class="attached-doc"
                    />
                    <div
                        class="close-btn doc"
                        @click="removeItem(index)"
                    >
                        <v-icon color="#fff" style="font-size: 18px !important;">mdi-close</v-icon>
                    </div>
                    <v-card-text class="pa-0 text-body-1">{{ file.name }}</v-card-text>
                </div>
            </div>
        </v-container>
        <v-container
            class="d-flex align-end gap-2 pa-2"
        >
            <v-btn
                v-if="isTicketSelected || messages.length > 0"
                outlined
                custom
                color="primary"
                @click="submitBtn"
                :loading="loading"
            >
                <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.6811 0.698053C15.5768 0.611509 15.4501 0.556371 15.3157 0.539062C15.1813 0.521752 15.0448 0.542984 14.922 0.600284L0.1875 7.51636V8.85462L6.3763 11.3301L10.346 17.4375H11.6845L15.9138 1.4273C15.9481 1.29618 15.9445 1.15802 15.9033 1.02891C15.8621 0.899801 15.785 0.785058 15.6811 0.698053ZM10.8581 16.161L7.44596 10.9114L12.6967 5.16047L11.8659 4.40194L6.57409 10.1977L1.47141 8.15663L14.6003 1.99402L10.8581 16.161Z" fill="#0066FF"/>
                </svg>
            </v-btn>
            <v-btn
                v-if="!isTicketSelected && messages.length == 0"
                outlined
                custom
                color="primary"
                @click="submitBtn"
                :loading="loading"
            >
                <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.6811 0.698053C15.5768 0.611509 15.4501 0.556371 15.3157 0.539062C15.1813 0.521752 15.0448 0.542984 14.922 0.600284L0.1875 7.51636V8.85462L6.3763 11.3301L10.346 17.4375H11.6845L15.9138 1.4273C15.9481 1.29618 15.9445 1.15802 15.9033 1.02891C15.8621 0.899801 15.785 0.785058 15.6811 0.698053ZM10.8581 16.161L7.44596 10.9114L12.6967 5.16047L11.8659 4.40194L6.57409 10.1977L1.47141 8.15663L14.6003 1.99402L10.8581 16.161Z" fill="#0066FF"/>
                </svg>
                <span class="pr-2">{{ $t('submit ticket') }}</span>
            </v-btn>
            <textarea
                placeholder="متن پیام را بنویسید"
                v-model="message"
                @keydown="submit"
                class="message-input flex-fill"
                :rows="rows"
                @input="adjustRows"
            >
            </textarea>
            <v-menu
                top
                offset-y
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        custom
                        outlined
                        v-bind="attrs"
                        v-on="on"
                    >
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_4608_8909)">
                            <path d="M11.7048 5.74899L10.5629 4.60824L4.85353 10.3165C4.62868 10.5414 4.45033 10.8084 4.32866 11.1023C4.207 11.3961 4.14441 11.7111 4.14446 12.0291C4.14451 12.3472 4.20721 12.6621 4.32897 12.9559C4.45073 13.2497 4.62916 13.5167 4.85409 13.7416C5.07902 13.9664 5.34604 14.1448 5.6399 14.2664C5.93375 14.3881 6.2487 14.4507 6.56674 14.4506C6.88479 14.4506 7.19971 14.3879 7.49353 14.2661C7.78734 14.1444 8.0543 13.9659 8.27916 13.741L15.1304 6.89086C15.8874 6.13375 16.3126 5.10695 16.3125 4.03634C16.3124 2.96573 15.887 1.93901 15.1298 1.18205C14.3727 0.425092 13.3459 -0.00010547 12.2753 1.96238e-08C11.2047 0.000105509 10.178 0.425505 9.42103 1.18262L2.22778 8.37474L2.21203 8.38936C0.0126562 10.5887 0.0126562 14.1527 2.21203 16.351C4.41141 18.5492 7.97541 18.5492 10.1748 16.351L10.1894 16.3352L10.1905 16.3364L15.1012 11.4269L13.9593 10.2861L9.04866 15.1945L9.03403 15.2091C8.28044 15.9612 7.25923 16.3836 6.19453 16.3836C5.12983 16.3836 4.10863 15.9612 3.35503 15.2091C2.98122 14.8349 2.685 14.3905 2.4834 13.9015C2.28179 13.4125 2.17876 12.8885 2.18022 12.3596C2.18168 11.8307 2.28761 11.3072 2.49192 10.8194C2.69623 10.3315 2.9949 9.88875 3.37078 9.51661L3.36966 9.51549L10.564 2.32337C11.5079 1.37837 13.0447 1.37837 13.9897 2.32337C14.9347 3.26837 14.9335 4.80399 13.9897 5.74787L7.13841 12.598C6.98508 12.739 6.78319 12.8154 6.57491 12.8111C6.36663 12.8068 6.16807 12.7222 6.02069 12.5749C5.8733 12.4277 5.78851 12.2292 5.78401 12.0209C5.77951 11.8127 5.85565 11.6107 5.99653 11.4572L11.7059 5.74787L11.7048 5.74899Z" fill="black"/>
                            </g>
                            <defs>
                            <clipPath id="clip0_4608_8909">
                            <rect width="18" height="18" fill="white"/>
                            </clipPath>
                            </defs>
                        </svg>
                    </v-btn>
                </template>
                <v-list class="px-4">
                    <v-list-item class="d-flex align-center justify-space-between pa-0">
                        <v-card-text class="text-heading-5 pa-0 pl-2">{{ $t('file') }}</v-card-text>
                        <v-file-input
                            style="display: none;"
                            ref="fileInput"
                            v-model="files"
                            multiple
                            @change="onAttach"
                        >
                        </v-file-input>
                        <v-btn
                            custom
                            outlined
                            @click="triggerFileInput"
                        >
                            <svg width="20" height="20" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.76575 2.29725C9.05246 2.4276 9.31336 2.60848 9.536 2.83125L14.012 7.30875C14.237 7.53375 14.417 7.794 14.5452 8.07825M8.76575 2.29725C8.42465 2.14241 8.05435 2.06236 7.67975 2.0625H5.84375C5.14756 2.0625 4.47988 2.33906 3.98759 2.83134C3.49531 3.32363 3.21875 3.99131 3.21875 4.6875V13.3125C3.21875 14.0087 3.49531 14.6764 3.98759 15.1687C4.47988 15.6609 5.14756 15.9375 5.84375 15.9375H12.1558C12.8519 15.9375 13.5196 15.6609 14.0119 15.1687C14.5042 14.6764 14.7808 14.0087 14.7808 13.3125V9.165C14.7808 8.78625 14.699 8.4165 14.5452 8.07825M8.76575 2.29725V6.5775C8.76575 6.97533 8.92379 7.35686 9.20509 7.63816C9.48639 7.91946 9.86793 8.0775 10.2657 8.0775L14.5452 8.07825" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </v-btn>
                    </v-list-item>
                    <!-- <v-list-item class="d-flex align-center justify-space-between pa-0">
                        <v-card-text class="text-heading-5 pa-0 pl-2">{{ $t('text') }}</v-card-text>
                        <v-btn
                            custom
                            outlined
                        >
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.75 4.5752H2.25M15.75 9.0752H2.25M11.325 13.5002H2.25" stroke="#030303" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </v-btn>
                    </v-list-item> -->
                    <!-- <v-list-item class="d-flex align-center justify-space-between pa-0">
                        <v-card-text class="text-heading-5 pa-0 pl-2">{{ $t('video') }}</v-card-text>
                        <v-btn
                            custom
                            outlined
                        >
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9.00001 3.99001H4.57126C4.21667 3.99001 3.86557 4.05995 3.53806 4.19582C3.21054 4.33169 2.91304 4.53084 2.6626 4.78184C2.41215 5.03285 2.21367 5.33079 2.07852 5.65861C1.94338 5.98642 1.87422 6.33768 1.87501 6.69226V11.3138C1.87501 12.0288 2.15908 12.7146 2.66472 13.2203C2.91509 13.4707 3.21232 13.6693 3.53945 13.8048C3.86657 13.9403 4.21718 14.01 4.57126 14.01H9.00001C9.7151 14.01 10.4009 13.7259 10.9065 13.2203C11.4122 12.7146 11.6963 12.0288 11.6963 11.3138V6.69301C11.6973 6.33827 11.6284 5.98681 11.4934 5.65878C11.3584 5.33074 11.1599 5.03259 10.9094 4.7814C10.6589 4.53022 10.3613 4.33094 10.0337 4.19501C9.70601 4.05908 9.35474 3.98916 9.00001 3.98926M16.125 7.07851V10.9298C16.125 11.1173 16.0718 11.3018 15.9713 11.4608C15.8695 11.6202 15.7254 11.7482 15.555 11.8305C15.3858 11.9152 15.1952 11.9476 15.0075 11.9235C14.8225 11.9013 14.647 11.8293 14.4998 11.715L12.081 9.77401C11.9648 9.67841 11.8709 9.55862 11.8057 9.42301C11.7406 9.28739 11.7058 9.1392 11.7038 8.98876C11.7038 8.83876 11.7375 8.69101 11.8035 8.55751C11.8725 8.43151 11.967 8.32126 12.081 8.23351L14.4998 6.30826C14.647 6.19354 14.8229 6.12143 15.0083 6.09976C15.1958 6.07576 15.3863 6.10801 15.555 6.19201C15.7228 6.27252 15.8649 6.39802 15.9655 6.55455C16.0662 6.71107 16.1214 6.89246 16.125 7.07851Z" stroke="#030303" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </v-btn>
                    </v-list-item> -->
                    <v-list-item class="d-flex align-center justify-space-between pa-0">
                        <v-card-text class="text-heading-5 pa-0 pl-2">{{ $t('image') }}</v-card-text>
                        <v-file-input
                            style="display: none;"
                            ref="fileInput"
                            v-model="files"
                            multiple
                            @change="onAttach"
                        >
                        </v-file-input>
                        <v-btn
                            custom
                            outlined
                            @click="triggerFileInput"
                        >
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.1797 2.625H5.80469C4.81013 2.625 3.8563 3.02009 3.15304 3.72335C2.44978 4.42661 2.05469 5.38044 2.05469 6.375V11.625C2.05469 12.1175 2.15168 12.6051 2.34014 13.0601C2.52859 13.515 2.80482 13.9284 3.15304 14.2767C3.8563 14.9799 4.81013 15.375 5.80469 15.375H12.1797C12.6721 15.375 13.1598 15.278 13.6148 15.0895C14.0697 14.9011 14.4831 14.6249 14.8313 14.2767C15.1796 13.9284 15.4558 13.515 15.6442 13.0601C15.8327 12.6051 15.9297 12.1175 15.9297 11.625V6.375C15.9297 5.88254 15.8327 5.39491 15.6442 4.93994C15.4558 4.48497 15.1796 4.07157 14.8313 3.72335C14.4831 3.37513 14.0697 3.09891 13.6148 2.91045C13.1598 2.722 12.6721 2.625 12.1797 2.625Z" stroke="#030303" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M2.24219 12.7502L4.30469 10.3502C4.57457 10.0822 4.92877 9.91559 5.30735 9.87869C5.68592 9.84178 6.06562 9.93682 6.38219 10.1477C6.69875 10.3586 7.07845 10.4536 7.45703 10.4167C7.8356 10.3798 8.18981 10.2132 8.45969 9.9452L10.2072 8.1977C10.7093 7.69387 11.3741 7.38485 12.083 7.32578C12.7918 7.26671 13.4986 7.46143 14.0772 7.8752L15.9447 9.3227M5.99219 7.6277C6.15568 7.6277 6.31758 7.59549 6.46863 7.53293C6.61968 7.47036 6.75693 7.37865 6.87254 7.26304C6.98814 7.14743 7.07985 7.01019 7.14242 6.85914C7.20498 6.70809 7.23719 6.54619 7.23719 6.3827C7.23719 6.2192 7.20498 6.0573 7.14242 5.90625C7.07985 5.7552 6.98814 5.61796 6.87254 5.50235C6.75693 5.38674 6.61968 5.29503 6.46863 5.23247C6.31758 5.1699 6.15568 5.1377 5.99219 5.1377C5.66199 5.1377 5.34532 5.26886 5.11184 5.50235C4.87836 5.73583 4.74719 6.0525 4.74719 6.3827C4.74719 6.71289 4.87836 7.02956 5.11184 7.26304C5.34532 7.49653 5.66199 7.6277 5.99219 7.6277Z" stroke="#030303" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </v-btn>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-container>
        <v-snackbar
            v-model="snakbar"
            :color="(snakbarColor ? snakbarColor : 'primary')"
            top
            style="z-index: 1000000000000 !important;"
        >
            {{ snakbarText }}
            <template v-slot:action="{ attrs }">
                <v-btn
                color="white"
                text
                v-bind="attrs"
                @click="snakbar = !snakbar"
                >
                {{ $t('close') }}
                </v-btn>
            </template>
        </v-snackbar>
    </v-container>
</template>

<script>
export default {
  props: {
    isTicketSelected: Boolean,
    messages: Array,
    isFormValid: Boolean,
    toggleSelectionTicket: Boolean,
    isMessageSend: Boolean,
    isTicketCanceled: Boolean
  },
  data () {
    return {
      message: null,
      files: [],
      allFiles: [],
      filePreviews: [],
      resolvedMessageAction: {
        action: null,
        type: null,
        body: null
      },
      rows: 1,
      loading: false,
      snakbar: false,
      snakbarColor: null,
      snakbarText: null
    }
  },
  methods: {
    triggerFileInput () {
      this.$refs.fileInput.$el.querySelector('input[type="file"]').click()
    },
    submit (e) {
      if (e.key === 'Enter') {
        if (e.shiftKey) {
          if (this.rows < 14) {
            this.rows++
            return
          } else {
            e.preventDefault()
            return
          }
        }
        if (this.message != null) {
          // text
          if (this.message != null && this.files.length == 0) {
            this.resolvedMessageAction.action = 'submit'
            this.resolvedMessageAction.type = 'text'
            this.resolvedMessageAction.body = this.message
          }
          // file + text
          if ((this.message != null || this.message == null) && this.files.length > 0) {
            this.resolvedMessageAction.action = 'submit'
            this.resolvedMessageAction.type = 'text/file'
            this.resolvedMessageAction.body = this.message
          }
          e.preventDefault()
          if (!this.isTicketSelected && this.messages.length == 0) {
            this.$emit('checkFormValidate')
            this.$nextTick(() => {
              if (this.isFormValid) {
                this.loading = true
                this.$emit('submit', this.resolvedMessageAction)
                if (this.rows > 1) {
                  this.rows = 1
                }
                this.message = null
                this.files = []
                this.filePreviews = []
              }
            })
          } else {
            this.loading = true
            this.$emit('submit', this.resolvedMessageAction)
            if (this.rows > 1) {
              this.rows = 1
            }
            this.message = null
            this.files = []
            this.allFiles = []
            this.filePreviews = []
          }
        } else {
          this.snakbarText = this.$t('write a message in related section')
          this.snakbarColor = 'red'
          this.snakbar = true
        }
      }
    },
    submitBtn () {
      if (this.message != null) {
        // text
        if (this.message != null && this.files.length == 0) {
          this.resolvedMessageAction.action = 'submit'
          this.resolvedMessageAction.type = 'text'
          this.resolvedMessageAction.body = this.message
        }
        // file + text
        if (this.message != null && this.files.length > 0) {
          this.resolvedMessageAction.action = 'submit'
          this.resolvedMessageAction.type = 'text/file'
          this.resolvedMessageAction.body = this.message
        }
        if (!this.isTicketSelected && this.messages.length == 0) {
          this.$emit('checkFormValidate')
          this.$nextTick(() => {
            if (this.isFormValid) {
              this.loading = true
              this.$emit('submit', this.resolvedMessageAction)
              if (this.rows > 1) {
                this.rows = 1
              }
              this.message = null
              this.files = []
              this.filePreviews = []
            }
          })
        } else {
          this.loading = true
          this.$emit('submit', this.resolvedMessageAction)
          if (this.rows > 1) {
            this.rows = 1
          }
          this.message = null
          this.files = []
          this.allFiles = []
          this.filePreviews = []
        }
      } else {
        this.snakbarText = this.$t('write a message in related section')
        this.snakbarColor = 'red'
        this.snakbar = true
      }
    },
    adjustRows () {
      const totalLineBreaks = (this.message.match(/\n/g) || []).length + 1
      this.rows = totalLineBreaks
    },
    onAttach () {
      if (this.files && this.files.length > 0) {
        const newFiles = Array.from(this.files)
        const uniqueFiles = newFiles.filter(
          (file) => !this.allFiles.some((existingFile) => existingFile.name === file.name && existingFile.type === file.type)
        )
        this.allFiles.push(...uniqueFiles)
        uniqueFiles.forEach((file) => {
          const preview = URL.createObjectURL(file)
          this.filePreviews.push({
            name: file.name,
            type: file.type,
            preview: preview
          })
        })
        this.$refs.fileInput.$el.querySelector('input[type="file"]').value = null
      }
      this.$emit('fileAttach', { files: this.allFiles })
    },
    resolveImgExtension (value) {
      if (value.includes('image')) {
        return true
      }
    },
    resolveDocExtension (value) {
      if (value.includes('application')) {
        return true
      }
    },
    removeItem (index) {
      this.filePreviews.splice(index, 1)
      this.files.splice(index, 1)
      this.allFiles.splice(index, 1)
    }
  },
  watch: {
    message (val) {
      if (val == null) {
        this.rows = 1
      }
    },
    toggleSelectionTicket (val) {
      this.message = null
      this.files = []
      this.filePreviews = []
    },
    isMessageSend (val) {
      this.loading = false
    },
    isTicketCanceled (val) {
      this.message = null
      this.files = []
      this.filePreviews = []
      this.allFiles = []
    }
  }
}
</script>

<style scoped>
.wrapper-send-message {
    position: relative;
    background-color: #fff;
    border-radius: 15px;
}
.wrapper-send-message .message-input {
    border: 1px solid #999999;
    padding: 4px 6px !important;
    /* height: 34px; */
    border-radius: 4px;
    resize: none;
    outline: none;
}
.wrapper-send-message .message-input:focus {
    border-color: #0066ff !important;
}
.wrapper-send-message .message-input::-webkit-scrollbar {
    display: none;
}
.wrapper-send-message .wrapper-files,
.wrapper-send-message .wrapper-images {
    position: relative;
}
.wrapper-send-message .wrapper-files {
    border: 1px solid silver;
    padding: 10px;
    border-radius: 4px;
}
.wrapper-send-message .attached-img {
    width: 60px;
    height: 60px;
    border-radius: 4px;
    border: 1px solid silver;
}
.wrapper-send-message .attached-doc {
    width: 40px;
    height: 40px;
}
.wrapper-send-message .close-btn.doc {
    width: 18px;
    height: 18px;
    background-color: #5f5959db;
    border-radius: 3px;
    cursor: pointer;
    position: absolute;
    right: 4px;
    top: 10px;
}
.wrapper-send-message .close-btn.img {
    width: 18px;
    height: 18px;
    background-color: #5f5959db;
    border-radius: 3px;
    cursor: pointer;
    position: absolute;
    top: -4px;
    right: -4px;
}
.wrapper-send-message .wrapper-attachment {
    padding: 12px 12px 0 12px !important;
    background-color: #fff;
    max-height: 200px;
    overflow-y: auto;
}
.wrapper-send-message .wrapper-attachment::-webkit-scrollbar {
  width: 4px;
  border-radius: 13px;
  margin-left: 5px;
}
.wrapper-send-message .wrapper-attachment::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 13px;
  margin-left: 5px;
}
.wrapper-send-message .wrapper-attachment::-webkit-scrollbar-thumb {
  background: #8888889f;
  border-radius: 13px;
  margin-left: 5px;
}
.wrapper-send-message .wrapper-attachment::-webkit-scrollbar-thumb:hover {
  background: #555555cb;
  border-radius: 13px;
  margin-left: 5px;
}
</style>
